import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { ROUTES } from '@/constants/routes';
import { Button } from '@/components/ui/button';

export default function LockScreen() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center p-8 text-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
        <Lock className="h-8 w-8 text-red-600" />
      </div>
      <h2 className="mb-2 text-2xl font-bold text-gray-900">Account Locked</h2>
      <p className="mb-2 text-gray-600 max-w-sm">
        Your trial has ended. Your data is safe and all your records are preserved.
      </p>
      <p className="mb-8 text-gray-500 text-sm max-w-sm">
        Activate a subscription to restore full access to your dashboard.
      </p>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Button asChild>
          <Link to={ROUTES.SUBSCRIPTION}>
            Activate Subscription →
          </Link>
        </Button>
        <Button variant="outline" asChild>
          <a href="mailto:techsupport@getfastclaim.com">
            Contact Fastclaim →
          </a>
        </Button>
      </div>
    </div>
  );
}
